import React, { useEffect, useState } from "react";
import Axios from "axios";
import TextField from "@mui/material/TextField";
import Navbar from "./Navbar";
import { useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message } from "antd";

function AddStatus() {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const history = useHistory();
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Add Status";
  }, []);

  const addToList = () => {
    setNameError(false);

    if (name === "") {
      setNameError(true);
      return;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    Axios.post(
      "/api/status/insertStatus",
      {
        StatusName: name,
      },
      config
    )
      .then(function (response) {
        message.success(" Added successfully");
        setTimeout(function () {
          history.push("/statuslist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Add Status" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "10px",
            fontSize: "25px",
          }}
        ></div>
        <div className="row mt-3 mb-4 pr-3 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body">
                <div className="row form-group  " style={{ padding: "10px" }}>
                  <div className="col-lg-6">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Status Name"
                      onChange={(e) => setName(e.target.value)}
                      error={nameError}
                    />
                  </div>
                </div>

                <div
                  className="float-right pr-3"
                  style={{ paddingTop: "40px" }}
                >
                  {" "}
                  <button
                    onClick={addToList}
                    className="btn btn-primary add-button"
                  >
                    {" "}
                    Add Status{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddStatus;
